import BaseXMLGenerator from './xlsx-tableexport-generator.js'
import { buildRowsInBatches } from './build-rows-in-batches.js'
import { getProjectFullID, dateFormat, amountFormat } from '@/data/filters/formatter.js'

const HEADERS = [
  '專案名稱',
  '案號',
  '負責人',
  '客戶',
  '建立日期',
  '金額',
  '人事成本',
  '發票支出',
  '狀態',
]

var XMLGenerator = new BaseXMLGenerator()
XMLGenerator.baseGenerate = XMLGenerator.generate

function buildProjectExportLookups(vm) {
  const clientById = {}
  for (const client of vm.$store.state.client.list) {
    clientById[client.ID] = client
  }

  const userById = {}
  for (const user of vm.$store.state.user.list) {
    userById[user.ID] = user
  }

  const taskIdToProjectId = {}
  for (const task of vm.$store.state.task.list) {
    taskIdToProjectId[task.ID] = task.ProjectID
  }

  const bonusByProjectId = {}
  for (const item of vm.$store.state.taskWorkingItem.list) {
    if (!item.BonusReleasedAt) continue
    const projectId = taskIdToProjectId[item.TaskID]
    if (projectId == null) continue
    bonusByProjectId[projectId] = (bonusByProjectId[projectId] || 0) + item.Bonus
  }

  return { clientById, userById, bonusByProjectId }
}

function buildProjectRow(data, lookups) {
  const row = []
  const client = lookups.clientById[data.ClientID] || {}
  const manager = lookups.userById[data.ManagerID] || { Profile: {} }
  const totalIssuedBonus = lookups.bonusByProjectId[data.ID] || 0

  const sumOfInvoiceExpenditure = (() => {
    if (!data.Receipts) return 0
    return data.Receipts.filter(o => o.Type == 'received').reduce(
      (sum, o) => sum + o.Amount,
      0
    )
  })()

  row.push(data.Name)
  row.push(getProjectFullID(data))
  row.push(manager.Profile.Name)
  row.push(client.Name)
  row.push(dateFormat(data.CreatedAt))
  if (
    (data.Status == '執行中' || data.Status == '已結案' || data.Status == '已完成') &&
    data.FinalAmount > 0
  ) {
    row.push(amountFormat(data.FinalAmount))
  } else {
    row.push(amountFormat(data.Amount))
  }
  row.push(amountFormat(totalIssuedBonus))
  row.push(amountFormat(sumOfInvoiceExpenditure))
  row.push(data.Status)

  return row
}

XMLGenerator.buildSheetData = async function (vm, datas, onProgress) {
  const lookups = buildProjectExportLookups(vm)
  const rows = await buildRowsInBatches(
    datas,
    data => buildProjectRow(data, lookups),
    onProgress
  )
  return { headers: HEADERS, rows }
}

XMLGenerator.generate = function (vm, datas) {
  const lookups = buildProjectExportLookups(vm)
  const rows = datas.map(data => buildProjectRow(data, lookups))
  return this.baseGenerate(rows, HEADERS)
}

export default XMLGenerator
